module.exports = "/assets/festival-menu-banner.png?W2Ja5aK";